import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";



export const byPassOTP = (proposalNo,cb) => async (dispatch) => {
        axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/d2c/bypassOTPAndSubmitApplication?proposalNumber=${proposalNo}`,{},{
        headers: {
            "Content-Type": "application/json",
             authorization:localStorage.getItem('token')
        },
    })
        .then((resp) => {
            if (
                resp &&
                resp.status === 200
            ) {
                toaster("success", resp.data.message);
                if(cb) {
                    cb(resp.data)
                }
            } else {
                toaster("error", resp.data.message);
            }
        })
        .catch((err) => {
            if(err.status === '401'){
                dispatch({
                    type: actionType.BYPASS_OTP,
                    payload: false,
                });
            }
        });
};
export const edcReTriggers = (proposalNumber, status) => async (dispatch) => {
    axios.post(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/edcTransaction?isEDCUpi=${status}&proposalNumber=${proposalNumber}`,'',
        {
            headers: {
                'Content-Type': 'application/json',
                authorization: localStorage.getItem('token'),
            },
        }
    )
    .then((resp) => {
        if (resp && resp.status === 200) {
            toaster('success', resp.data.message);
        } else {
            toaster('error', resp.data.message);
        }
    })
    .catch((err) => {
        if (err.status === '401') {
            dispatch({
                type: actionType.EDC_RETRIGGER,
                payload: false,
            });
        }
    });
};
